import { User } from "../types/User";
import { WatchFace } from "./WatchFace.dto";

export enum WFComplicationType {
  Infograph = 'infograph',
  California = 'california',
  Meridian = 'meridian',
  InfographModular = 'infographModular',
  InfographModularColored = 'infographModularColored', // iOS 16 Only
  XLarge = 'xLarge',
  XLargeColored = 'xLargeColored', // iOS 16 Only
  ModularCompact = 'modularCompact',
  ModularCompactColored = 'modularCompactColored', // iOS 16 Only
  ModularDuo = 'modularDuo', // SE7 and hight (no SE & SE2)
}

export enum WFFamilyType {
  Circular = 'circular',
  Rectangular = 'rectangular',
}

export enum ComplicationCategory {
  Battery = 'Battery',
  Weather = 'Weather',
  DateAndTime = 'Date & Time',
  Activity = 'Activity',
  Steps = 'Steps',
  Pulse = 'Pulse',
  Distance = 'Distance',
  Exercise = 'Exercise',
  Stand = 'Stand',
  Image = 'Image',
  Miscellaneous = 'Miscellaneous',
}

export enum ComplicationPermissionType {
  LOCATION = 'location',
  HEALTH_STEP_COUNT = 'healthStepCount',
  HEALTH_DISTANCE_WALKING_RUNNING = 'healthDistanceWalkingRunning',
  HEALTH_HEART_RATE = 'healthHeartRate',
  HEATH_ACTIVE_ENERGY_BURNED = 'healthActiveEnergyBurned',
  HEALTH_ACTIVITY_SUMMARY = 'healthActivitySummary',
}

export enum ComplicationStatus {
  PUBLISH = 'publish',
  DRAFT = 'draft',
  DELETED = 'deleted',
}

export enum ComplicationStatusWithAll {
  PUBLISH = 'publish',
  DRAFT = 'draft',
  DELETED = 'deleted',
  ALL = 'all',
}

export enum ComplicationType {
  ADMIN = 'admin',
  CUSTOMER = 'customer',
}


export interface Complication {
  id: string;
  status: ComplicationStatus;
  type: ComplicationType;
  complicationId: string;
  fileId: string;
  fileUrl: string;
  previewId: string;
  previewUrl: string;
  name: string;
  slot: string;
  familyType: WFFamilyType;
  permissionTypes: string[];
  categories: string[];
  position: number;
  supportedComplicationTypes: WFComplicationType[];
  watchfaceId: string;
  watchfaces: WatchFace[]
  userId: string;
  user: User;
  isLastVersion: boolean;

  readonly createdAt: string;
  readonly updatedAt: string;
}
